import type { App } from 'vue'

export type UserModule = (app: App<Element>) => void

export enum DetectionOutputFormat {
  YoloRaw = 'yolo-raw',
  Yolo26EndToEnd = 'yolo26-end-to-end',
}

export interface Detection {
  topLeftX: number
  topLeftY: number
  bottomRightX: number
  bottomRightY: number
  classId: number
  confidence: number
  area?: number // Pre-computed area for faster IoU calculation
}
